/*global google*/
import Autocomplete from 'react-google-autocomplete';

import React, { useEffect, useRef } from 'react';
import config from '@/config';

const { googleAPiKey } = config;
export const MapSearchInput = ({ onChange, value, ...props }) => {
  const ref = useRef();

  useEffect(() => {
    ref.current.value = value || '';
  }, [value]);

  return (
    <div className="form-element editor-mode">
      <Autocomplete
        ref={ref}
        apiKey={googleAPiKey}
        onPlaceSelected={(place) => {
          let obj = { address: place?.formatted_address || '' };
          if ('address_components' in place) {
            for (const component of place?.address_components) {
              switch (component.types[0]) {
                case 'administrative_area_level_2':
                  break;
                case 'administrative_area_level_1':
                  obj.state = component;
                  break;
                case 'locality':
                  obj.city = component;
                  break;
                case 'country':
                  obj.country = component;
                  break;
                case 'postal_code':
                  obj.postal_code = component;
                  break;
                default:
              }
            }
          }
          onChange?.(obj);
        }}
        options={{
          types: ['(regions)'],
          componentRestrictions: { country: ['au', 'nz'] },
        }}
        defaultValue={value}
        onChange={(e) => {
          if (!e?.target?.value) {
            onChange(null);
          }
        }}
        className="ant-input"
        {...props}
      />
    </div>
  );
};
